import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "src/app/components/components.module";
import {  DepositIdebitActionPage } from "./deposit-idebit-action";

@NgModule({
  declarations: [DepositIdebitActionPage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class DepositIDebitActionPageModule {}
